import $ from 'jquery';

export default (function () {
    
    var form = function (settings) {
        this.config = {};
        this.items = settings.items || [];
        this.config.method = settings.method || 'POST';
    }
    
    form.prototype.out = function () {
        var self = this;
        var html = '<form';
        html += ' method="' + self.config.method + '">';
        
        // output the fields
        for (var i = 0; i < self.items.length; i++) {
            var item = self.items[i];
            if (!item.elemkey) item.elemkey = 'key';
            if (!item.elemvalue) item.elemvalue = 'value';
            html += '<div class="formentry">';
            if (item.label) {
                html += '<label for="' + item.key + '">' + item.label + '</label>';
            }
            switch (item.type) {
                case 'text':
                    html += '<input type="text"'
                    if (item.key) {
                        html += ' name="' + item.key + '"';
                    }
                    if (item.value) {
                        html += ' value="' + item.value + '"';
                    }
                    if (item.maxLength) {
                        html += ' maxLength="' + item.maxLength + '"';
                    }
                    html += '>';
                    break;
                case 'textarea':
                    html += '<textarea'
                    if (item.key) {
                        html += ' name="' + item.key + '"';
                    }
                    html += '>';
                    if (item.value) {
                        html += item.value;
                    }
                    html += '</textarea>';
                    break;
                case 'select':
                    html += '<select name="' + item.key + '">';
                    for (var j = 0; j < item.elements.length; j++) {
                        html += '<option value="' + item.elements[j][item.elemkey] + '"';
                        if (item.elements[j][item.elemkey] == item.value) {
                            html += ' selected';
                        }
                        html += '>' + item.elements[j][item.elemvalue] + '</option>';
                    }
                    html += '</select>';
                    break;
                case 'number':
                    html += '<input type="number"'
                    if (item.key) {
                        html += ' name="' + item.key + '"';
                    }
                    if (item.value) {
                        html += ' value="' + item.value + '"';
                    }
                    if (item.min !== undefined) {
                        html += ' min="' + item.min + '"';
                    }
                    if (item.step !== undefined) {
                        html += ' step="' + item.step + '"';
                    }
                    html += '>';
                    break;
            }
            html += '</div>';
        }
        html += '</form>';
        return html;
    }    
    
    return {
        new: function (settings) {
            var f = new form(settings);
            return f;
        }
    }    
})();